export function getDisplayRange(pagination, totalCount) {
  let startIndex = 0;
  if (totalCount > 0) startIndex = (pagination.current - 1) * pagination.pageSize + 1;

  const endIndex = Math.min(startIndex + pagination.pageSize - 1, totalCount);
  return `${Intl.NumberFormat().format(startIndex)}-${Intl.NumberFormat().format(endIndex)}`;
}
